"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildWhatsAppShareOrderLink = void 0;
const extractPhoneNumber_1 = require("../../../utils/extractPhoneNumber");
const isGenericReseller_1 = require("../../../utils/helpers/isGenericReseller");
const constants_1 = require("../constants");
const helpers_1 = require("../helpers");
const messages_1 = require("../messages");
const buildWhatsAppShareOrderLink = (params) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const message = yield buildMessage(params);
    const encodedMessage = encodeURIComponent(message);
    const phone = buildPhone((_b = (_a = params.reseller) === null || _a === void 0 ? void 0 : _a.whatsapp) !== null && _b !== void 0 ? _b : '');
    return `${constants_1.WHATSAPP_API_URL}/send?phone=${phone}&text=${encodedMessage}`;
});
exports.buildWhatsAppShareOrderLink = buildWhatsAppShareOrderLink;
const buildPhone = (phoneNumber) => `55${(0, extractPhoneNumber_1.extractPhoneNumber)(phoneNumber)}`;
const buildMessage = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { cartItems, reseller } = params;
    const totalPrice = (0, helpers_1.getTotalBRLPriceByCart)(cartItems);
    const isGenericRe = (0, isGenericReseller_1.isGenericReseller)(reseller.catalogSlug);
    if (isGenericRe) {
        return (0, messages_1.getClosedSaleMessage)(Object.assign(Object.assign({}, params), { totalPrice }));
    }
    return (0, messages_1.getApproveOrderMessage)(Object.assign(Object.assign({}, params), { totalPrice }));
});
